// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { PaginationFragment } from '../../../../shared/graphql/fragments/generated/pagination.fragment.generated';
import { ElectronicInvoiceDataFragment } from '../../fragments/generated/electronic-invoice-data.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchElectronicInvoiceDataPaginatedQueryVariables = Types.Exact<{
  searchElectronicInvoiceDataPaginatedRequestDTO: Types.SearchElectronicInvoiceDataPaginatedRequestDtoInput;
}>;


export type SearchElectronicInvoiceDataPaginatedQueryResult = { __typename?: 'Query', searchElectronicInvoiceDataPaginated: { __typename?: 'SearchElectronicInvoiceDataPaginatedResponseDTO', pagination: { __typename?: 'PaginationDTO', limit: number, offset: number, total: number }, results: Array<{ __typename?: 'ElectronicInvoiceDataDTO', eInvoiceSendTimestamp: LocalDateTime | null, eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, invoiceId: number, xsdValidationError: string | null, invoice: { __typename?: 'InvoiceDTO', amount: number, block: string | null, date: LocalDate | null, id: number, ownerCorporateDataId: number, progressive: number, masterInvoice: boolean, holder: { __typename?: 'InvoiceHolderDTO', id: number, fiscalCode: string | null, vatNumber: string | null, fullName: string, name: string | null, surname: string | null, corpName: string | null, address: string | null, city: string | null, cityId: number | null, mail: string | null, mobile: string | null, invoiceHolderType: Types.InvoiceHolderTypeDto, invoiceDocumentType: Types.InvoiceDocumentTypeDto | null } | null }, resourceValidationResults: Array<{ __typename?: 'ResourceValidationResultDTO', resourceId: number, validationErrors: Array<{ __typename?: 'ValidationErrorDTO', errorCode: string, fieldName: string | null, translationKey: string } | null> | null }> }> } };

export const SearchElectronicInvoiceDataPaginatedGql = gql`
    query SearchElectronicInvoiceDataPaginated($searchElectronicInvoiceDataPaginatedRequestDTO: SearchElectronicInvoiceDataPaginatedRequestDTOInput!) {
  searchElectronicInvoiceDataPaginated(
    request: $searchElectronicInvoiceDataPaginatedRequestDTO
  ) {
    pagination {
      ...Pagination
    }
    results {
      ...ElectronicInvoiceData
    }
  }
}
    ${PaginationFragment}
${ElectronicInvoiceDataFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchElectronicInvoiceDataPaginatedInjectable extends Apollo.Query<SearchElectronicInvoiceDataPaginatedQueryResult, SearchElectronicInvoiceDataPaginatedQueryVariables> {
    override document = SearchElectronicInvoiceDataPaginatedGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */